// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__zADXf","pageNumber":"Paginator_pageNumber__vArFU","selectedPage":"Paginator_selectedPage__ZnJPS"};